import { render, staticRenderFns } from "./PersonTabNav.vue?vue&type=template&id=9f1a2ca8&scoped=true&"
import script from "./PersonTabNav.vue?vue&type=script&lang=js&"
export * from "./PersonTabNav.vue?vue&type=script&lang=js&"
import style0 from "./PersonTabNav.vue?vue&type=style&index=0&id=9f1a2ca8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1a2ca8",
  null
  
)

export default component.exports